export default class BlockObserver {
	constructor(blocks) {

		this.blocks 				= blocks;
		this.blockObserver 			= null
		this.isIntersecting 		= this.isIntersecting.bind(this)
		this.init 					= this.init.bind(this)
		this.unmount 				= this.unmount.bind(this)

		if( window.document.body.classList.contains('nav--light') ){
			this.navStartState = true
		} else {
			this.navStartState = false
		}

		this.init()

	}

	init() {

		this.blockObserver = new IntersectionObserver(this.isIntersecting, {
			root: null, // Use the viewport as the root
			rootMargin: '-200px 0px 0px 0px', // No additional margin
			threshold: 0, // Trigger when 0 of the video is visible
		})

		this.blocks && this.blocks.forEach((block) => {
			// Start observing the block element
			this.blockObserver.observe(block)
		})
	}

	isIntersecting(entries) {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				entry.target.classList.add("visible");
			}
		})
	}

	unmount(){
		this.blockObserverAnim = null
		this.blocks && this.blocks.forEach( (block) => {
			// Start observing the block element
			this.blockObserver.unobserve(block)
		})
	}

}